import React, { FC } from "react";
import MainLayout from "../../Layouts/MainLayout";
import Permission from "../molecules/Permission";
import SectionHeader from "../molecules/SectionHeader";
import WindowHeightComponent from "../../Layouts/WindowHeight";
import AccessControl from "../molecules/AccessControl";
import AccessDenied from "../atoms/AccessDenied";
import useAccessCheckLoading from "../../../utils/useAccessCheckLoading";
import Spinner from "../atoms/Spinner";
// Renders the PermissionPage component with a main layout, section header, and 
// the Permission component inside a WindowHeightComponent for responsive design.

const PermissionPage: FC = () => {
   const accessCheckLoading = useAccessCheckLoading()
   return (
      <>
         <MainLayout>
         <AccessControl
          requiredPermissions={[
          {
            permission: "configurations",
            types: ["create"],
          },
        ]}
        renderNoAccess={ accessCheckLoading ? <Spinner/> :<AccessDenied />}
      >
            <SectionHeader  back = {true} title={"Create permissions"}></SectionHeader>
            <WindowHeightComponent className={""}>
               <div className="p-3">
                  <Permission />
               </div>
            </WindowHeightComponent>
            </AccessControl>
         </MainLayout>
      </>
   )
}
export default PermissionPage;